/*  eslint no-extend-native: ["error", { "exceptions": ["String"] }]    */

String.prototype.capitalize = function () {
  return this.charAt(0).toUpperCase() + this.slice(1).toLowerCase();
};

String.prototype.firstLowerCase = function () {
  return this.charAt(0).toLowerCase() + this.slice(1);
};
